import { Fragment, lazy, Suspense, useContext } from 'react';
import Marcas from './marcas/Marcas';
import Vendidos from './vendidos/Vendidos';
import AuthContext from '../../hooks/AuthContext';

const AlbumHome = lazy(() => import('./albumHome/AlbumHome'));
const Destaques = lazy(() => import('./destaques/Destaques'));
const EmpresaHome = lazy(() => import('./empresa/EmpresaHome'));
const IntervaloMensalidade = lazy(() => import('./intervaloMensalidade/IntervaloMensalidade'));
const IntervaloPreco = lazy(() => import('./intervaloPreco/IntervaloPreco'));
const Listagem = lazy(() => import('./listagem/Listagem'));
const NoticiasHome = lazy(() => import('./noticiasHome/NoticiasHome'));
const Servicos = lazy(() => import('./servicos/Servicos'));
const TestemunhosHome = lazy(() => import('./testemunhosHome/TestemunhosHome'));
const Tipos = lazy(() => import('./tipos/Tipos'));
const Recentes = lazy(() => import('./utimasEntradas/Recentes'));
const BannersHome = lazy(() => import('./bannersHome/BannersHome'));

export default function SectionList({
  infoJson,
  allLista,
  filteredCarros,
  allListaCarros,
  setFilteredCarros,
  selectedItems,
  addToCompare,
  removeFromCompare,
  allinfoText,
  pontosVenda,
  ordenacao,
}) {
  const { state } = useContext(AuthContext);

  const renderSwitch = param => {
    switch (param) {
      case 'Destaques':
        return (
          <>
            {state.Destaques.existe && (
              <>
                <Suspense fallback={<></>}>
                  <Destaques
                    allLista={allLista}
                    infoJson={infoJson}
                    selectedItems={selectedItems}
                    addToCompare={addToCompare}
                    removeFromCompare={removeFromCompare}
                    allinfoText={allinfoText}
                    tipoDestaque={1}
                    top={true}
                  />
                </Suspense>
              </>
            )}
          </>
        );
      case 'UltimasEntradas':
        return (
          <>
            {state.Zonas?.Layout.UltimasEntradas.existe && (
              <>
                {allLista.length !== 0 && (
                  <>
                    <Suspense fallback={<></>}>
                      <Recentes allLista={allLista} infoJson={infoJson} allinfoText={allinfoText} />
                    </Suspense>
                  </>
                )}
              </>
            )}
          </>
        );
      case 'Vendidos':
        return (
          <>
            {state.Zonas?.Layout.Vendidos.existe && (
              <>
                {allLista.length !== 0 && (
                  <>
                    <Suspense fallback={<></>}>
                      <Vendidos allLista={allLista} infoJson={infoJson} allinfoText={allinfoText} />
                    </Suspense>
                  </>
                )}
              </>
            )}
          </>
        );
      case 'Marcas':
        return (
          <>
            {state.Zonas?.Layout.Marcas?.existe && (
              <>
                {allLista.length !== 0 && (
                  <>
                    <Suspense fallback={<></>}>
                      <Marcas allLista={allLista} infoJson={infoJson} />
                    </Suspense>
                  </>
                )}
              </>
            )}
          </>
        );
      case 'Servicos':
        return (
          <>
            {state.Zonas?.Layout.Servicos.existe && (
              <>
                <Suspense fallback={<></>}>
                  <Servicos infoJson={infoJson} allinfoText={allinfoText} />
                </Suspense>
              </>
            )}
          </>
        );
      case 'Tipos':
        return (
          <>
            {state.Zonas?.Layout.Tipos.existe && (
              <>
                {allLista.length !== 0 && (
                  <>
                    <Suspense fallback={<></>}>
                      <Tipos allLista={allLista} infoJson={infoJson} allinfoText={allinfoText} />
                    </Suspense>
                  </>
                )}
              </>
            )}
          </>
        );
      case 'intervaloPreco':
        return (
          <>
            {state.Zonas?.Layout.intervaloPreco.existe && (
              <>
                <Suspense fallback={<></>}>
                  <IntervaloPreco
                    infoJson={infoJson}
                    allLista={allLista}
                    allinfoText={allinfoText}
                  />
                </Suspense>
              </>
            )}
          </>
        );
      case 'Listagem':
        return (
          <>
            {state.Zonas?.Layout.Carros.existe && (
              <>
                <Suspense fallback={<></>}>
                  <Listagem
                    infoJson={infoJson}
                    filteredCarros={filteredCarros}
                    allListaCarros={allListaCarros}
                    allLista={allLista}
                    setFilteredCarros={setFilteredCarros}
                    selectedItems={selectedItems}
                    addToCompare={addToCompare}
                    removeFromCompare={removeFromCompare}
                    allinfoText={allinfoText}
                    pontosVenda={pontosVenda}
                  />
                </Suspense>
              </>
            )}
          </>
        );
      case 'AlbumClientes':
        return (
          <>
            {state.Zonas?.Layout.AlbumClientes.existe && (
              <>
                <Suspense fallback={<></>}>
                  <AlbumHome infoJson={infoJson} allinfoText={allinfoText} />
                </Suspense>
              </>
            )}
          </>
        );
      case 'Noticias':
        return (
          <>
            {state.Zonas?.Layout.Noticias.existe && (
              <>
                <Suspense fallback={<></>}>
                  <NoticiasHome infoJson={infoJson} allinfoText={allinfoText} />
                </Suspense>
              </>
            )}
          </>
        );
      case 'Testemunhos':
        return (
          <>
            {state.Zonas?.Layout.Testemunhos.existe && (
              <>
                <Suspense fallback={<></>}>
                  <TestemunhosHome infoJson={infoJson} allinfoText={allinfoText} />
                </Suspense>
              </>
            )}
          </>
        );
      case 'intervaloMensalidades':
        return (
          <>
            {state.Zonas?.Layout.intervaloMensalidades.existe && (
              <>
                <Suspense fallback={<></>}>
                  <IntervaloMensalidade
                    infoJson={infoJson}
                    allLista={allLista}
                    allinfoText={allinfoText}
                  />
                </Suspense>
              </>
            )}
          </>
        );
      case 'QuemSomos':
        return (
          <>
            {state.Zonas?.Layout.QuemSomos.existe && (
              <>
                <Suspense fallback={<></>}>
                  <EmpresaHome infoJson={infoJson} allinfoText={allinfoText} />
                </Suspense>
              </>
            )}
          </>
        );
      case 'Banners':
        return (
          <>
            {infoJson.Layout.Banners.existe && (
              <>
                <Suspense fallback={<></>}>
                  <BannersHome infoJson={infoJson} />
                </Suspense>
              </>
            )}
          </>
        );
      default:
        return <></>;
    }
  };

  return (
    <>
      {ordenacao
        .sort((a, b) => a.ordenador - b.ordenador)
        .map(item => {
          return <Fragment key={item.id}>{renderSwitch(item.nome)}</Fragment>;
        })}
    </>
  );
}
